import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const AnnouncementBar = () => {
  const { isRTL } = useLanguage();

  const scrollToPrograms = () => {
    const el = document.getElementById('programs');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] h-10 bg-charcoal-100/95 backdrop-blur-sm border-b border-gold/25 flex items-center justify-center cursor-pointer group select-none"
      onClick={scrollToPrograms}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && scrollToPrograms()}
      aria-label={isRTL ? 'انتقلي إلى البرامج' : 'Go to Programs'}
    >
      <p className={`text-xs sm:text-sm text-cream-300 tracking-wide flex items-center gap-1.5 sm:gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}>
        <span className="text-gold font-medium tracking-wide">Healthy Tuesday</span>
        <span className="text-cream-500 mx-0.5">·</span>
        <span className="hidden sm:inline">
          {isRTL
            ? 'انضمي إلى مجتمع الشفاء الأسبوعي المجاني'
            : 'Join our free weekly healing community'}
        </span>
        <span className="sm:hidden">
          {isRTL ? 'مجتمع شفاء مجاني أسبوعي' : 'Free weekly healing community'}
        </span>
        <span
          className={`text-gold text-sm transition-transform duration-200 ${
            isRTL
              ? 'group-hover:-translate-x-0.5'
              : 'group-hover:translate-x-0.5'
          }`}
        >
          {isRTL ? '←' : '→'}
        </span>
      </p>
    </div>
  );
};

export default AnnouncementBar;
